import { Component, output, OutputEmitterRef } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SetUpTwoFactorScreen } from '../set-up-two-factor.component';
@Component({
  selector: 'app-set-up-choose-method',
  imports: [MatButton, TranslateModule],
  templateUrl: './set-up-choose-method.component.html',
  styleUrls: [
    '../../login-form/login-form.component.scss',
    '../set-up-two-factor.component.scss',
  ],
})
export class SetUpChooseMethodComponent {
  dismiss: OutputEmitterRef<void> = output<void>();
  changeScreen: OutputEmitterRef<SetUpTwoFactorScreen> =
    output<SetUpTwoFactorScreen>();

  onDismiss() {
    this.dismiss.emit();
  }

  onAppSetUp() {
    this.changeScreen.emit(SetUpTwoFactorScreen.AUTHENTICATOR_APP);
  }

  onEmailSetUp() {
    this.changeScreen.emit(SetUpTwoFactorScreen.EMAIL);
  }
}
